import React from 'react'
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import { PricingItem, PricingItemContent, PricingItemfooter, PricingItemHeader, PricingItemPrix } from './Style';

export default function Pricing(props) {
  return (
    <ScrollAnimation animateIn="animate__fadeIn">
      <PricingItem color={props.color} active={props.active}>
        <PricingItemHeader color={props.color}><h5>Basic</h5></PricingItemHeader>
        <PricingItemPrix color={props.color}> <h4>99 $ / MONTH</h4></PricingItemPrix>
        <PricingItemContent>
          <p>Unlimited access courses</p>
          <p>Progress Report Available</p>
          <p>Certificate after completion</p>
          <p>Progress Report Available</p>
          <p>Unlimited access courses</p>
        </PricingItemContent>
        <PricingItemfooter color={props.color}>
          <a href="#">Select Plan</a>
        </PricingItemfooter>
      </PricingItem>
    </ScrollAnimation>
  )
}
